import {handleActions} from 'redux-actions';
import {Record, List, Map} from 'immutable';

import {sendNewSuccess} from '../inbox-message-composer/actions';
import {setInboxType} from '../conversation-center/actions';
import * as Actions from './actions';

const State = Record({
    fetching: true,
    receivers: List(),
    selectedReceivers: Map(),
    activeNodePath: List(),
});

const clearSelectedReceivers = state =>
    state.merge({
        selectedReceivers: Map(),
        activeNodePath: List(),
    });

export default handleActions(
    {
        [Actions.fetchReceivers.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchReceiversFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
        [Actions.fetchReceiversSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                receivers: List(payload.response),
            }),
        [Actions.showDetail.type]: (state, {payload}) =>
            state.merge({
                activeNodePath: state.activeNodePath.concat(payload.nodeIndex),
            }),
        [Actions.hideDetail.type]: state =>
            state.merge({
                activeNodePath: state.activeNodePath.pop(),
            }),
        [Actions.clearReceivers.type]: state => clearSelectedReceivers(state),
        [Actions.removeReceiver.type]: (state, {payload}) => {
            // receiver.participants[] always contains 2 items and the second one is a receiver's ID
            const receiverPath = state.selectedReceivers.findKey(receivers =>
                receivers.some(receiver => receiver.participants[1] === payload.receiverId),
            );
            const updatedSelectedReceivers = state.selectedReceivers
                .get(receiverPath)
                .filter(receiver => receiver.participants[1] !== payload.receiverId);

            if (updatedSelectedReceivers.size === 0) {
                return state.merge({
                    selectedReceivers: state.selectedReceivers.delete(receiverPath),
                });
            }

            return state.merge({
                selectedReceivers: state.selectedReceivers.set(receiverPath, updatedSelectedReceivers),
            });
        },
        [Actions.toggleSelectReceiver.type]: (state, {payload}) => {
            const currentReceiversPath = state.activeNodePath.reduce((acc, nodeIndex, i) => {
                if (i === 0) {
                    return nodeIndex;
                }
                return `${acc}.${nodeIndex}`;
            }, '');
            const currentNodeReceivers = state.selectedReceivers.get(currentReceiversPath) || List();

            let updatedNodeReceivers;
            const receiverIdIndex = currentNodeReceivers.findIndex(
                receiver =>
                    payload.receiver.participants && receiver.participants[1] === payload.receiver.participants[1],
            );
            if (receiverIdIndex === -1) {
                updatedNodeReceivers = currentNodeReceivers.push(payload.receiver);
            } else {
                updatedNodeReceivers = currentNodeReceivers.delete(receiverIdIndex);
            }

            return state.merge({
                selectedReceivers: state.selectedReceivers.set(currentReceiversPath, updatedNodeReceivers),
            });
        },
        [Actions.insertReceivers.type]: (state, {payload}) =>
            state.merge({
                selectedReceivers: payload.selectedReceivers,
            }),
        [sendNewSuccess.type]: state => clearSelectedReceivers(state),
        [setInboxType.type]: state => clearSelectedReceivers(state),
    },
    new State(),
);
